import { Injector } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PanelBarTemplate } from '../../../../../shared/expandable-panelbar/expandable-panelbar.component';
import { PanelbarService } from '../../../../../shared/expandable-panelbar/expandable-panelbar.service';
import { CtwrRequestService } from '../../../ctwr.service';
import { RequestDetailService } from '../detail.service';
import { ToolingComponent } from '../../tooling-components/tooling.component';
import { ToolingComponentCategoryPanelbar } from './tooling-component-category.panelbar';
import { ApprovalStatus } from '../../../workflow.service';

export class ToolingApprovalPanelbar extends PanelBarTemplate {

    private readonly formBuilder: FormBuilder;
    private readonly requestService: CtwrRequestService;
    private readonly detailService: RequestDetailService;
    private readonly toolingComponent: ToolingComponent;
    private readonly panelbarService: PanelbarService;

    constructor(
        private readonly injector: Injector,
    ) {
        super();

        this.formBuilder = injector.get(FormBuilder);
        this.requestService = injector.get(CtwrRequestService);
        this.detailService = injector.get(RequestDetailService);
        this.toolingComponent = injector.get(ToolingComponent);
        this.panelbarService = injector.get(PanelbarService);
    }


    /**
     * For each Part Approval in the dataItem, create an editForm
     * @param dataItem PartApprovalMatrix Dto
     */
    setApprovalData(dataItem: any) {
        this.reset();
        const form: FormGroup = this.formBuilder.group(PartEditForm);
        form.reset(dataItem);
        if (!dataItem.IsToolingItemsEnabled) {
            form.get('toolingBtn').disable();
        }
        this.forms.push(form);
        if (dataItem.ToolingComponentCategories.length > 0) {
            dataItem.ToolingComponentCategories.forEach(cc => {
                cc.PartId = dataItem.PartId;
                cc.PartNumber = dataItem.PartNumber;
                cc.RequestId = dataItem.RequestId;
                this.addPanelBar(this.getToolingComponentCategoryPanelbar(cc));
            });
        }
    }


    /**
     * 
     * @param parts
     */
    setApprovalStatus(part: any) {
        let _status: ApprovalStatus;
        _status = part.PartStatus;
        this.approvalStatus.next(_status);
    }



    /**
     * Initialize and return Tooling Component Category Panelbar instance
     * @param cc - Tooling Component Category
     */
    private getToolingComponentCategoryPanelbar(cc: any): ToolingComponentCategoryPanelbar {
        const pb = new ToolingComponentCategoryPanelbar(this.injector);
        pb.title = cc.CategoryName;
        pb.id = cc.ComponentCategoryId;
        pb.iconStack = false;
        pb.iconClass = 'fa-pie-chart secondary-purple';
        pb.setComponentCategoryData(cc);
        return pb;
    }



    /**
     * 
     * @param part 
     * @param requestId 
     */
    private setPartDetail(part: any, requestId: string): Promise<any> {
        return this.toolingComponent.setPartDetail({
            PartNumber: part.PartNumber,
            ProcessName: part.ProcessName,
            ProcessId: part.ProcessId,
            RequestId: requestId,
            PartId: part.Id
        }, false);
    }

    /**
     * 
     */
    private readonly handleToolingComponent = (form: FormGroup) => {
        let _part: any;
        this.toolingComponent.formDialog.save = ({ dataItem }) => {
            this.handleComponentCategorySave(dataItem, form);
        }
        if (form.value.IsPrimary) {
            _part = this.detailService.primaryPart.value[0];
        } else {
            _part = this.detailService.impactedParts.value
                .find(x => x.Id === form.value.PartId);
        }
        if (_part) {

            this.setPartDetail(_part, form.value.ParentEditDataItem.RequestId)
                .then(x => {
                    this.panelbarService.openDialog(this.toolingComponent.formDialog);
                    this.toolingComponent.open(false);
                });
        }
    }


    /**
     * 
     */
    private readonly handleComponentCategorySave = (dataItem: any, form: FormGroup) => {
        const RequestId = form.value.ParentEditDataItem.RequestId;
        const PartId = form.value.PartId;
        const ccData = this.toolingComponent.getFormData();
        if (RequestId && PartId && ccData) {
            this.requestService.save(ccData, false, `/UpdateToolingComponent?requestId=${RequestId}&partId=${PartId}`)
                .then(x => this.detailService.refreshWorkApprovalMatrix());
        }
    }


    controls = [{
        type: 'action',
        title: 'Tooling Components',
        text: 'Tooling Components',
        iconClass: 'fa fa-fw fa-pencil-square-o',
        name: 'toolingBtn',
        primary: true,
        stretch: true,
        click: this.handleToolingComponent,
    },
    ]
}

const PartEditForm = {
    toolingBtn: [],
    ParentEditDataItem: [],
    PartId: [],
    PartNumber: [],
    PartTitle: [],
    IsPrimary: [],
}

